// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1YX0X","ranges":"BmiRanges_ranges__QjtwA"};